(function () {
	if (customElements.get("bundle-upsell")) return;

	class BundleUpsell extends HTMLElement {
		connectedCallback() {
			this.sectionId = this.dataset.sectionId;
			this.discountRate = Number(this.dataset.discountRate || 20);
			this.checkoutLabel = this.dataset.checkoutLabel || "Siirry kassalle";
			this.addLabel =
				this.dataset.addLabel ||
				(typeof variantStrings !== "undefined"
					? variantStrings.addToCart
					: "Add to cart");
			this.section =
				this.closest(".product-section") ||
				document.getElementById(`shopify-section-${this.sectionId}`) ||
				document;

			this.mainProduct = this.parseJson("[data-bundle-main-product-json]", {});
			this.products = this.parseJson("[data-bundle-products-json]", []);
			if (!Array.isArray(this.products) || this.products.length === 0) return;

			this.toggle = this.querySelector("[data-bundle-toggle]");
			this.toggleRow = this.querySelector("[data-bundle-toggle-row]");
			this.toggleLabel = this.querySelector("[data-bundle-toggle-label]");
			this.bundleTitle = this.querySelector("[data-bundle-title]");
			this.bundleDescription = this.querySelector("[data-bundle-description]");
			this.mainVariantPicker = this.querySelector(
				"[data-bundle-main-variant-picker]",
			);
			this.mainImage = this.querySelector("[data-bundle-main-image]");
			this.mainPrice = this.querySelector("[data-bundle-main-price]");
			this.addonRow = this.querySelector("[data-bundle-addon-row]");
			this.addonImage = this.querySelector("[data-bundle-addon-image]");
			this.addonTitle = this.querySelector("[data-bundle-addon-title]");
			this.addonPrice = this.querySelector("[data-bundle-addon-price]");
			this.addonPicker = this.querySelector("[data-bundle-addon-picker]");
			this.addonLabel = this.querySelector("[data-bundle-addon-variant-label]");
			this.addonSelect = this.querySelector("[data-bundle-addon-select]");
			this.summaryLabel = this.querySelector("[data-bundle-summary-label]");
			this.summaryCompare = this.querySelector("[data-bundle-compare]");
			this.summaryFinal = this.querySelector("[data-bundle-final]");
			this.summarySavings = this.querySelector("[data-bundle-savings]");
			this.plus = this.querySelector("[data-bundle-plus]");
			this.modal = this.querySelector("[data-bundle-modal]");
			this.modalOriginalParent = this.modal?.parentNode || null;
			this.modalOriginalNextSibling = this.modal?.nextSibling || null;
			this.openModalButton = this.querySelector("[data-bundle-open-modal]");
			this.closeModalButtons = this.querySelectorAll("[data-bundle-close-modal]");
			this.bundleSubmit = this.querySelector("[data-bundle-submit]");
			this.bundleError = this.querySelector("[data-bundle-error]");

			this.currentAddonProduct =
				this.findProductById(this.dataset.addonProductId) || this.products[0];
			this.currentAddonVariant =
				this.findVariantById(
					this.currentAddonProduct,
					this.dataset.addonVariantId,
				) || this.getFirstAvailableVariant(this.currentAddonProduct);

			this.onToggleChange = this.updateState.bind(this);
			this.onAddonSelectChange = this.handleAddonSelectChange.bind(this);
			this.onOpenModal = this.openModal.bind(this);
			this.onCloseModal = this.closeModal.bind(this);
			this.onModalClick = this.handleModalClick.bind(this);
			this.onDocumentKeydown = this.handleDocumentKeydown.bind(this);
			this.onSubmitCapture = this.handleSubmitCapture.bind(this);
			this.onBundleSubmit = this.handleBundleSubmit.bind(this);
			this.onMainInputChange = this.handleMainVariantChange.bind(this);

			this.toggle?.addEventListener("change", this.onToggleChange);
			this.addonSelect?.addEventListener("change", this.onAddonSelectChange);
			this.openModalButton?.addEventListener("click", this.onOpenModal);
			this.closeModalButtons.forEach((button) => {
				button.addEventListener("click", this.onCloseModal);
			});
			this.modal?.addEventListener("click", this.onModalClick);
			this.bundleSubmit?.addEventListener("click", this.onBundleSubmit);
			this.mainVariantPicker?.addEventListener(
				"change",
				this.onMainInputChange,
			);
			this.getMainVariantInput()?.addEventListener(
				"change",
				this.onMainInputChange,
			);
			document.addEventListener("submit", this.onSubmitCapture, true);
			document.addEventListener("keydown", this.onDocumentKeydown);

			if (
				typeof subscribe === "function" &&
				typeof PUB_SUB_EVENTS !== "undefined"
			) {
				this.unsubscribeVariantChange = subscribe(
					PUB_SUB_EVENTS.variantChange,
					(event) => {
						if (String(event?.data?.sectionId) === String(this.sectionId)) {
							this.queueStateUpdate();
						}
					},
				);
			}

			this.renderAddonProduct();
			this.updateState();
			this.queueStateUpdate();
		}

		disconnectedCallback() {
			this.toggle?.removeEventListener("change", this.onToggleChange);
			this.addonSelect?.removeEventListener(
				"change",
				this.onAddonSelectChange,
			);
			this.openModalButton?.removeEventListener("click", this.onOpenModal);
			this.closeModalButtons?.forEach((button) => {
				button.removeEventListener("click", this.onCloseModal);
			});
			this.modal?.removeEventListener("click", this.onModalClick);
			this.bundleSubmit?.removeEventListener("click", this.onBundleSubmit);
			this.mainVariantPicker?.removeEventListener(
				"change",
				this.onMainInputChange,
			);
			this.getMainVariantInput()?.removeEventListener(
				"change",
				this.onMainInputChange,
			);
			document.removeEventListener("submit", this.onSubmitCapture, true);
			document.removeEventListener("keydown", this.onDocumentKeydown);
			if (this.modal && !this.modal.hidden) {
				document.body.style.overflow = this.previousBodyOverflow || "";
				this.modal.hidden = true;
				this.modal.setAttribute("aria-hidden", "true");
			}
			this.restoreModalPosition();
			if (typeof this.unsubscribeVariantChange === "function") {
				this.unsubscribeVariantChange();
			}
		}

		parseJson(selector, fallback) {
			const el = this.querySelector(selector);
			if (!el) return fallback;
			try {
				return JSON.parse(el.textContent.trim());
			} catch (error) {
				return fallback;
			}
		}

		queueStateUpdate() {
			window.requestAnimationFrame(() => this.updateState());
			window.setTimeout(() => this.updateState(), 250);
		}

		isActive() {
			return Boolean(this.toggle?.checked);
		}

		findProductById(productId) {
			return this.products.find(
				(product) => String(product.id) === String(productId),
			);
		}

		findVariantById(product, variantId) {
			return product?.variants?.find(
				(variant) => String(variant.id) === String(variantId),
			);
		}

		getFirstAvailableVariant(product) {
			return (
				product?.variants?.find((variant) => variant.available) ||
				product?.variants?.[0] ||
				null
			);
		}

		getMainVariantInput() {
			return document
				.getElementById(`product-form-${this.sectionId}`)
				?.querySelector('input[name="id"]');
		}

		getMainVariant() {
			const picker =
				this.mainVariantPicker ||
				document.getElementById(`variant-picker-${this.sectionId}`);
			const selectedVariant = this.parseNestedJson(
				picker?.querySelector("[data-selected-variant]"),
			);
			if (selectedVariant) return selectedVariant;

			const variantId =
				this.getMainVariantInput()?.value || this.dataset.mainVariantId;

			const fromProduct = this.mainProduct?.variants?.find(
				(variant) => String(variant.id) === String(variantId),
			);
			return (
				fromProduct ||
				this.getFirstAvailableVariant(this.mainProduct) ||
				null
			);
		}

		parseNestedJson(el) {
			if (!el) return null;
			try {
				return JSON.parse(el.textContent.trim());
			} catch (error) {
				return null;
			}
		}

		handleMainVariantChange() {
			this.queueStateUpdate();
		}

		handleAddonSelectChange() {
			this.currentAddonVariant =
				this.findVariantById(this.currentAddonProduct, this.addonSelect.value) ||
				this.currentAddonVariant;
			if (this.currentAddonVariant) {
				this.dataset.addonVariantId = this.currentAddonVariant.id;
			}
			this.updateState();
		}

		handleModalClick(event) {
			const productButton = event.target.closest("[data-bundle-product-id]");
			if (!productButton || !this.modal?.contains(productButton)) return;

			const product = this.findProductById(productButton.dataset.bundleProductId);
			if (!product) return;

			this.currentAddonProduct = product;
			this.currentAddonVariant = this.getFirstAvailableVariant(product);
			this.dataset.addonProductId = product.id;
			if (this.currentAddonVariant) {
				this.dataset.addonVariantId = this.currentAddonVariant.id;
			}

			this.renderAddonProduct();
			this.updateModalSelection();
			this.closeModal();
			this.updateState();
		}

		openModal() {
			if (!this.modal) return;
			this.lastFocusedElement = document.activeElement;
			this.previousBodyOverflow = document.body.style.overflow;
			this.mountModalAtDocumentRoot();
			this.modal.hidden = false;
			this.modal.setAttribute("aria-hidden", "false");
			document.body.style.overflow = "hidden";

			if (typeof trapFocus === "function") {
				trapFocus(this.modal, this.modal.querySelector("button"));
			} else {
				this.modal.querySelector("button")?.focus();
			}
		}

		closeModal() {
			if (!this.modal || this.modal.hidden) return;
			this.modal.hidden = true;
			this.modal.setAttribute("aria-hidden", "true");
			document.body.style.overflow = this.previousBodyOverflow || "";
			this.restoreModalPosition();

			if (typeof removeTrapFocus === "function") {
				removeTrapFocus(this.lastFocusedElement || this.openModalButton);
			} else {
				(this.lastFocusedElement || this.openModalButton)?.focus?.();
			}
		}

		mountModalAtDocumentRoot() {
			if (!this.modal || this.modal.parentNode === document.body) return;
			this.modalOriginalParent = this.modal.parentNode;
			this.modalOriginalNextSibling = this.modal.nextSibling;
			document.body.appendChild(this.modal);
		}

		restoreModalPosition() {
			if (
				!this.modal ||
				!this.modalOriginalParent ||
				this.modal.parentNode === this.modalOriginalParent
			) {
				return;
			}

			if (
				this.modalOriginalNextSibling &&
				this.modalOriginalNextSibling.parentNode === this.modalOriginalParent
			) {
				this.modalOriginalParent.insertBefore(
					this.modal,
					this.modalOriginalNextSibling,
				);
			} else {
				this.modalOriginalParent.appendChild(this.modal);
			}
		}

		handleDocumentKeydown(event) {
			if (event.key === "Escape" && this.modal && !this.modal.hidden) {
				this.closeModal();
			}
		}

		renderAddonProduct() {
			if (!this.currentAddonProduct || !this.currentAddonVariant) return;

			if (this.addonTitle) {
				this.addonTitle.textContent = this.currentAddonProduct.title;
			}

			this.updateImage(
				this.addonImage,
				this.getVariantImage(this.currentAddonVariant, this.currentAddonProduct),
				this.currentAddonProduct.title,
			);

			this.renderAddonSelect();
			this.updateModalSelection();
		}

		renderAddonSelect() {
			if (!this.addonSelect || !this.currentAddonProduct) return;

			const variants = this.currentAddonProduct.variants || [];
			const hasRealVariants =
				variants.length > 1 ||
				(variants[0]?.title && variants[0].title !== "Default Title");

			this.addonPicker?.classList.toggle("hidden", !hasRealVariants);
			if (!hasRealVariants) {
				this.currentAddonVariant =
					this.getFirstAvailableVariant(this.currentAddonProduct) ||
					this.currentAddonVariant;
				return;
			}

			this.addonSelect.innerHTML = "";
			variants.forEach((variant) => {
				const option = document.createElement("option");
				option.value = variant.id;
				option.textContent = `${variant.title}${
					variant.available ? "" : " - Loppuunmyyty"
				}`;
				option.disabled = !variant.available;
				option.selected =
					String(variant.id) === String(this.currentAddonVariant?.id);
				this.addonSelect.appendChild(option);
			});

			const selectedStillAvailable = this.findVariantById(
				this.currentAddonProduct,
				this.addonSelect.value,
			);
			this.currentAddonVariant =
				selectedStillAvailable ||
				this.getFirstAvailableVariant(this.currentAddonProduct);
			if (this.currentAddonVariant) {
				this.addonSelect.value = this.currentAddonVariant.id;
			}

			const optionName = this.getFirstOptionName(this.currentAddonProduct);
			if (this.addonLabel) {
				this.addonLabel.textContent = optionName;
			}
		}

		getFirstOptionName(product) {
			const option = product?.options?.[0];
			if (!option) return "vaihtoehto";
			if (typeof option === "string") return option;
			return option.name || "vaihtoehto";
		}

		updateModalSelection() {
			this.modal
				?.querySelectorAll("[data-bundle-product-id]")
				.forEach((button) => {
					const isSelected =
						String(button.dataset.bundleProductId) ===
						String(this.currentAddonProduct?.id);
					button.classList.toggle("is-selected", isSelected);
					const badge = button.querySelector("[data-bundle-modal-badge]");
					if (badge) badge.textContent = isSelected ? "Valittu" : "Valitse";
				});
		}

		updateState() {
			const active = this.isActive();
			const mainVariant = this.getMainVariant();
			if (mainVariant) this.dataset.mainVariantId = mainVariant.id;
			if (this.currentAddonVariant) {
				this.dataset.addonVariantId = this.currentAddonVariant.id;
			}

			this.dataset.active = active ? "true" : "false";
			this.toggleRow?.classList.toggle("is-active", active);
			if (this.toggleLabel) {
				this.toggleLabel.textContent =
					this.toggleLabel.dataset.activeLabel || "Lisää ravinto-ohjelma mukaan";
			}
			if (this.bundleTitle) {
				this.bundleTitle.textContent = active
					? this.bundleTitle.dataset.activeTitle || "Rakenna kokonaisuus"
					: this.bundleTitle.dataset.inactiveTitle || "Pelkkä treeniohjelma";
			}
			if (this.bundleDescription) {
				this.bundleDescription.textContent = active
					? this.bundleDescription.dataset.activeDescription ||
						"Yhdistä treeniohjelma ja ravinto-ohjelma. Saat molemmat samalla tilauksella ja -20 % alennuksella."
					: this.bundleDescription.dataset.inactiveDescription ||
						"Ravinto-ohjelma ei ole mukana. Lisää se mukaan ja saat bundle-edun käyttöön.";
			}
			if (this.addonRow) this.addonRow.hidden = !active;
			if (this.plus) this.plus.hidden = !active;

			if (mainVariant) {
				if (this.mainPrice) this.mainPrice.textContent = this.formatMoney(mainVariant.price);
				this.updateImage(
					this.mainImage,
					this.getVariantImage(mainVariant, this.mainProduct),
					this.mainProduct.title,
				);
			}

			if (this.currentAddonVariant) {
				if (this.addonPrice) {
					this.addonPrice.textContent = this.formatMoney(
						this.currentAddonVariant.price,
					);
				}
				this.updateImage(
					this.addonImage,
					this.getVariantImage(
						this.currentAddonVariant,
						this.currentAddonProduct,
					),
					this.currentAddonProduct?.title,
				);
			}

			const mainPrice = Number(mainVariant?.price || 0);
			const addonPrice = active ? Number(this.currentAddonVariant?.price || 0) : 0;
			const originalPrice = mainPrice + addonPrice;
			const finalPrice = active
				? Math.round(originalPrice * ((100 - this.discountRate) / 100))
				: mainPrice;
			const savings = originalPrice - finalPrice;

			if (this.summaryLabel) {
				this.summaryLabel.textContent = active
					? this.summaryLabel.dataset.activeLabel || "Bundle-hinta"
					: this.summaryLabel.dataset.inactiveLabel || "Tuotehinta";
			}
			if (this.summaryCompare) {
				this.summaryCompare.textContent = this.formatMoney(originalPrice);
			}
			if (this.summaryFinal) {
				this.summaryFinal.textContent = this.formatMoney(finalPrice);
			}
			if (this.summarySavings) {
				this.summarySavings.textContent = `Säästät ${this.formatMoney(savings)}`;
			}

			this.syncDynamicCheckout(active);
			this.syncSubmitButtons(active);
		}

		getVariantImage(variant, product) {
			return (
				this.getImageSrc(variant?.featured_image) ||
				this.getImageSrc(variant?.featured_media?.preview_image) ||
				this.getImageSrc(variant?.image) ||
				this.getImageSrc(product?.featured_image) ||
				this.getImageSrc(product?.images?.[0])
			);
		}

		getImageSrc(image) {
			if (!image) return "";
			if (typeof image === "string") return this.normalizeImageUrl(image);
			return this.normalizeImageUrl(image.src || image.url || "");
		}

		normalizeImageUrl(src) {
			if (!src) return "";
			if (src.startsWith("//")) return `${window.location.protocol}${src}`;
			return src;
		}

		getSizedImageUrl(src, width) {
			const normalizedSrc = this.normalizeImageUrl(src);
			if (!normalizedSrc || !width) return normalizedSrc;

			try {
				const url = new URL(normalizedSrc, window.location.origin);
				const supportsWidthParameter =
					url.hostname === window.location.hostname ||
					url.hostname.endsWith(".shopify.com") ||
					url.hostname.endsWith(".shopifycdn.com") ||
					url.hostname.endsWith(".shopifycdn.net") ||
					url.pathname.includes("/cdn/shop/");

				if (!supportsWidthParameter) return normalizedSrc;
				url.searchParams.set("width", String(width));
				return url.toString();
			} catch (error) {
				return normalizedSrc;
			}
		}

		updateImage(container, src, alt) {
			if (!container) return;
			if (!src) {
				container.innerHTML = '<div class="bundle-upsell__image-placeholder"></div>';
				return;
			}

			let image = container.querySelector("img");
			if (!image) {
				container.innerHTML = "";
				image = document.createElement("img");
				image.className = "bundle-upsell__image";
				image.loading = "lazy";
				container.appendChild(image);
			}

			image.removeAttribute("data-srcset");
			image.removeAttribute("data-sizes");

			const widths = [80, 120, 180];
			const sizedSources = widths.map((width) =>
				this.getSizedImageUrl(src, width),
			);
			const supportsResponsiveSources = new Set(sizedSources).size > 1;
			const fallbackSrc = supportsResponsiveSources
				? sizedSources[sizedSources.length - 1]
				: src;

			if (supportsResponsiveSources) {
				image.srcset = sizedSources
					.map((source, index) => `${source} ${widths[index]}w`)
					.join(", ");
				image.sizes = "(max-width: 749px) 56px, 72px";
			} else {
				image.removeAttribute("srcset");
				image.removeAttribute("sizes");
			}

			if (image.src !== fallbackSrc) image.src = fallbackSrc;
			image.alt = alt || "";
		}

		formatMoney(cents) {
			if (typeof window.formatMoney === "function") {
				return window.formatMoney(cents);
			}

			const amount = (Number(cents || 0) / 100).toFixed(2).replace(".", ",");
			return `€${amount}`;
		}

		getProductForms() {
			return [
				document.getElementById(`product-form-${this.sectionId}`),
				document.getElementById(`sticky-bar-product-form-${this.sectionId}`),
			].filter(Boolean);
		}

		syncDynamicCheckout(active) {
			this.section
				.querySelectorAll(".product-form__checkout")
				.forEach((checkout) => {
					if (active) {
						checkout.dataset.bundleHidden = "true";
						checkout.hidden = true;
					} else if (checkout.dataset.bundleHidden === "true") {
						delete checkout.dataset.bundleHidden;
						checkout.hidden = false;
					}
				});
		}

		syncSubmitButtons(active) {
			this.getProductForms().forEach((form) => {
				const button = form.querySelector('[name="add"]');
				if (!button || this.isUnavailableButton(button)) return;

				this.setButtonLabel(button, active ? this.checkoutLabel : this.addLabel);
			});

			this.syncBundleSubmitButton();
		}

		syncBundleSubmitButton() {
			if (!this.bundleSubmit) return;

			const mainVariant = this.getMainVariant();
			const active = this.isActive();
			const addonAvailable = Boolean(this.currentAddonVariant?.available);
			const disabled = !mainVariant?.available || (active && !addonAvailable);

			this.setButtonLabel(this.bundleSubmit, this.checkoutLabel);
			this.bundleSubmit.toggleAttribute("disabled", disabled);
			this.bundleSubmit.setAttribute("aria-disabled", disabled ? "true" : "false");
			this.bundleSubmit.dataset.status = disabled ? "sold-out" : "available";
		}

		isUnavailableButton(button) {
			return (
				button.disabled ||
				button.dataset.status === "sold-out" ||
				button.dataset.status === "unavailable"
			);
		}

		setButtonLabel(button, text) {
			if (!button || !text) return;
			let label = button.querySelector(".button__label");
			if (!label) {
				label = button.querySelector(".button__content span") || button.querySelector("span");
			}
			if (!label) return;

			label.textContent = text;
			label.setAttribute("data-label", text);
			button.setAttribute("data-button-text", text);
		}

		handleSubmitCapture(event) {
			const form = event.target;
			if (!this.isBundleForm(form) || !this.isActive()) return;

			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
			this.submitBundle(form);
		}

		handleBundleSubmit(event) {
			event.preventDefault();
			this.submitBundle();
		}

		isBundleForm(form) {
			if (!(form instanceof HTMLFormElement)) return false;
			if (form.dataset.type !== "add-to-cart-form") return false;
			return [
				`product-form-${this.sectionId}`,
				`sticky-bar-product-form-${this.sectionId}`,
			].includes(form.getAttribute("id"));
		}

		async submitBundle(form = null) {
			const button =
				form?.querySelector('[name="add"]') || this.bundleSubmit;
			if (
				button?.disabled ||
				button?.getAttribute("aria-disabled") === "true" ||
				button?.dataset.status === "sold-out" ||
				button?.dataset.status === "unavailable"
			) {
				return;
			}

			const mainVariant = this.getMainVariant();
			const active = this.isActive();
			const mainVariantId =
				mainVariant?.id ||
				form?.querySelector('input[name="id"]')?.value ||
				this.dataset.mainVariantId;
			const addonVariantId = active
				? this.currentAddonVariant?.id || this.dataset.addonVariantId
				: null;
			const quantity = Math.max(
				1,
				Number(form?.querySelector('[name="quantity"]')?.value || 1),
			);

			if (!mainVariantId || (active && !addonVariantId)) {
				this.handleFormError(form, "Tuotevalintaa ei voitu lisätä koriin.");
				return;
			}

			this.setFormLoading(form, true);
			this.handleFormError(form, false);

			try {
				const response = await fetch(this.getCartAddUrl(), {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/json",
						"X-Requested-With": "XMLHttpRequest",
					},
					body: JSON.stringify({
						items: this.buildCartItems(mainVariantId, addonVariantId, quantity),
					}),
				});
				const data = await response.json().catch(() => ({}));

				if (!response.ok || data.status) {
					throw new Error(
						data.description ||
							data.message ||
							"Tuotteita ei voitu lisätä koriin.",
					);
				}

				window.location.href = this.getCheckoutUrl();
			} catch (error) {
				this.handleFormError(form, error.message);
				this.setFormLoading(form, false);
			}
		}

		buildCartItems(mainVariantId, addonVariantId, quantity) {
			const itemMap = new Map();
			[mainVariantId, addonVariantId].filter(Boolean).forEach((variantId) => {
				const key = String(variantId);
				itemMap.set(key, (itemMap.get(key) || 0) + quantity);
			});

			return Array.from(itemMap, ([id, itemQuantity]) => ({
				id: Number(id),
				quantity: itemQuantity,
			}));
		}

		getCartAddUrl() {
			const url = window.routes?.cart_add_url || "/cart/add";
			return url.endsWith(".js") ? url : `${url}.js`;
		}

		getCheckoutUrl() {
			const root = window.Shopify?.routes?.root || "/";
			return `${root.endsWith("/") ? root : `${root}/`}checkout`;
		}

		setFormLoading(form, isLoading) {
			const productForm = form?.closest("product-form");
			const button =
				form?.querySelector('[name="add"]') || this.bundleSubmit;
			const spinner =
				button?.querySelector(".loading-overlay__spinner") ||
				productForm?.querySelector(".loading-overlay__spinner");

			if (isLoading) {
				button?.setAttribute("aria-disabled", "true");
				button?.classList.add("loading");
				spinner?.classList.remove("hidden");
			} else {
				button?.removeAttribute("aria-disabled");
				button?.classList.remove("loading");
				spinner?.classList.add("hidden");
				this.updateState();
			}
		}

		handleFormError(form, message) {
			this.handleBundleError(message);

			const productForm = form?.closest("product-form");
			if (productForm && typeof productForm.handleErrorMessage === "function") {
				productForm.handleErrorMessage(message);
				return;
			}

			const wrapper = productForm?.querySelector(
				".product-form__error-message-wrapper",
			);
			const text = wrapper?.querySelector(".product-form__error-message");
			if (!wrapper || !text) return;

			wrapper.toggleAttribute("hidden", !message);
			if (message) text.textContent = message;
		}

		handleBundleError(message) {
			if (!this.bundleError) return;
			this.bundleError.toggleAttribute("hidden", !message);
			if (message) this.bundleError.textContent = message;
		}
	}

	customElements.define("bundle-upsell", BundleUpsell);
})();
